import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalData } from '../modal.service';

@Component({
	selector: 'app-modal-footer',
	templateUrl: './modal-footer.component.html',
})
export class ModalFooterComponent {
	@Input() state: Partial<ModalData>;
	@Output() modalCancel = new EventEmitter<void>();
	@Output() modalConfirm = new EventEmitter<void>();

	onCancel() {
		this.modalCancel.emit();
	}

	onConfirm() {
		this.modalConfirm.emit();
	}

	shouldDisableCancelButton(): boolean {
		return !!(this.state.cancelButton?.disabled || this.state.confirmButton?.loading);
	}

	shouldDisableConfirmButton(): boolean {
		return !!this.state.confirmButton?.disabled;
	}
}
